import { useState } from 'react';
import { Dialog } from '@/ui/Dialog';
import { DataGrid } from './DataGrid';
import type { LookupSpec } from './types';

/**
 * Delphi Form906 (seçim penceresi) karşılığı: lookup listesinden bir satır seçilir,
 * YANSITMA_IMPORT/EXPORT eşlemesiyle düzenlenen satıra aktarılır.
 */
export function LookupDialog({ spec, row, open, onClose, onPick }: {
  spec: LookupSpec;
  row: Record<string, any>;
  open: boolean;
  onClose: () => void;
  onPick: (values: Record<string, any>) => void;
}) {
  const [selected, setSelected] = useState<Record<string, any> | null>(null);
  const pick = (r: Record<string, any> | null) => {
    if (!r) return;
    onPick(spec.apply(r, row));
    onClose();
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()} title={spec.title} className="h-[80vh] w-[min(1000px,96vw)]"
      footer={<>
        <button className="btn" onClick={onClose}>Vazgeç</button>
        <button className="btn btn-primary" disabled={!selected} onClick={() => pick(selected)}>Seç</button>
      </>}>
      <div className="h-full min-h-[50vh]">
        {open && (
          <DataGrid
            queryKey={['lookup', spec.title, JSON.stringify(row)]}
            fetch={(q) => spec.fetch(q, row)}
            onSelectionChange={setSelected}
            onRowOpen={pick}
            filterRow
            height="100%"
          />
        )}
      </div>
    </Dialog>
  );
}
